// Google Tag Manager container loader.
//
// WHY THIS IS NOT IN THE <head>
// The standard GTM snippet loads the container on every page view. That is safe
// only when every tag inside the container is itself consent-gated. This
// container (GTM-TX7DH28Q) is not: it carries Meta, TikTok and Snapchat pixels
// that fire on container load. Google Consent Mode does NOT gate third-party
// tags — `consent default denied` only suppresses Google's own tags — so those
// pixels would run before the user has answered the cookie banner.
//
// Instead the container is loaded once the user has granted `statistic` or
// `marketing` consent (see CookieConsentUtils.setCookiesBasedOnPreferences).
// The Consent Mode defaults and the gtag shim still ship in the document head
// (src/app/layout.tsx) so consent signals are queued on dataLayer before the
// container arrives and are replayed to it in order.
//
// ponytail: hardcoded container ID — it is a public value and the same across
// environments. Move to a runtime env var only if int/prod need separate
// containers.
const GTM_ID = "GTM-TX7DH28Q";
const GTM_SRC = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;

let _loaded = false;

/**
 * Inject the GTM container. Idempotent, browser-only.
 * MUST only be called after the user has granted statistic or marketing
 * consent (callers enforce this).
 */
export function initGtm(): void {
  if (_loaded) return;
  if (typeof window === "undefined" || typeof document === "undefined") return;

  try {
    const w = window as unknown as { dataLayer?: unknown[] };
    w.dataLayer = w.dataLayer || [];

    if (document.querySelector(`script[src="${GTM_SRC}"]`)) {
      _loaded = true;
      return;
    }

    // GTM measures container start time from this event.
    w.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

    const script = document.createElement("script");
    script.async = true;
    script.src = GTM_SRC;
    document.head.appendChild(script);

    _loaded = true;
  } catch (error) {
    console.error("GTM init failed:", error);
  }
}
